import yousersjs from '@yola/yousersjs';
import i18n from 'src/js/modules/i18n';
import partner from 'src/js/modules/partner';
import analytics from 'src/js/modules/analytics';

const register = (userData) => (dispatch, getState) =>
  new Promise(async (resolve, reject) => {
    const state = getState();
    const locale = i18n.selectors.getLocale(state);
    const csrfInstance = yousersjs.csrfInit();
    let token;

    try {
      token = await csrfInstance.get();
    } catch (error) {
      console.error('Failed to get csrf token', error);
      reject(error.response);
    }

    let visitorFingerprint = null;
    let fingerprintRequestId = null;

    try {
      const { visitorId, requestId } = await analytics.fingerprint.getVisitorData();

      visitorFingerprint = visitorId;
      fingerprintRequestId = requestId;
    } catch (error) {
      console.error('[FP] Get data:', error);
    }

    const data = {
      ...userData,
      locale,
      csrfmiddlewaretoken: token,
      partner_id: partner.accessors.getPartnerId(),
      vfp: visitorFingerprint,
      fprid: fingerprintRequestId,
    };

    try {
      await yousersjs.requests.register(data);
      resolve();
    } catch (error) {
      console.error('Failed to register user', error);
      reject(error.response);
    }
  });

export default register;
